/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail portal back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { LimitedEnterprisePortalProperties } from '../model';
/**
 * EnterprisePortalApi - axios parameter creator
 * @export
 */
export const EnterprisePortalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterprisePortalControllerGetEnterprisePortalProperties: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/enterprise-portal/getEnterprisePortalProperties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnterprisePortalApi - functional programming interface
 * @export
 */
export const EnterprisePortalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnterprisePortalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterprisePortalControllerGetEnterprisePortalProperties(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LimitedEnterprisePortalProperties>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterprisePortalControllerGetEnterprisePortalProperties(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterprisePortalApi.enterprisePortalControllerGetEnterprisePortalProperties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnterprisePortalApi - factory interface
 * @export
 */
export const EnterprisePortalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnterprisePortalApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterprisePortalControllerGetEnterprisePortalProperties(options?: any): AxiosPromise<LimitedEnterprisePortalProperties> {
            return localVarFp.enterprisePortalControllerGetEnterprisePortalProperties(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnterprisePortalApi - object-oriented interface
 * @export
 * @class EnterprisePortalApi
 * @extends {BaseAPI}
 */
export class EnterprisePortalApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterprisePortalApi
     */
    public enterprisePortalControllerGetEnterprisePortalProperties(options?: RawAxiosRequestConfig) {
        return EnterprisePortalApiFp(this.configuration).enterprisePortalControllerGetEnterprisePortalProperties(options).then((request) => request(this.axios, this.basePath));
    }
}

